<h2 class="preview-title-text">Preview</h2>
<!--if not starter-->
<h3
  class="preview-desc-text"
  *ngIf="!isStarterUser; else previewDescTextStarter"
>
  Preview tile last updated: {{ refreshDate }} PST. Request a refresh via
  <a
    href="https://illuminate.zendesk.com/hc/en-us/requests/new?ticket_form_id=21621854042395"
    target="_blank"
    >Support</a
  >.
</h3>
<!--else-->
<ng-template #previewDescTextStarter>
  <h3 class="preview-desc-text">
    Preview tile last updated: {{ refreshDate }} PST.
  </h3>
</ng-template>
<!--/if-->
<metric-settings-tooltip
  [name]="metric?.long_name"
  [desc]="metric?.definition"
></metric-settings-tooltip>
<metric-settings-tile
  [district]="district"
  [goals]="goals"
  [selectedMetricData]="selectedMetricData"
  [metric]="metric"
></metric-settings-tile>
<div class="save-changes-explanation-div">
  <!--if not starter-->
  <p
    class="save-changes-explanation-text"
    *ngIf="!isStarterUser; else saveChangesExplanationTextStarter"
  >
    If this metric is visible, actual changes can take up to 24 hours to display
    on your Schoolzilla dashboards. If this metric is hidden and you would like
    to see updated data, please request a refresh via
    <a
      href="https://illuminate.zendesk.com/hc/en-us/requests/new?ticket_form_id=21621854042395"
      target="_blank"
      >Support</a
    >.
  </p>
  <!--else-->
  <ng-template #saveChangesExplanationTextStarter>
    <p class="save-changes-explanation-text">
      If this metric is visible, actual changes can take up to 24 hours to
      display on your dashboards. If this metric is hidden and you would like to
      see updated data, please request a refresh via
      <live-chat [rgpTenantId]="rgpTenantId" class="live-chat"></live-chat>.
    </p>
  </ng-template>
  <!--/if-->
</div>
